import { useState } from "react";
import TermOrdersBannerTemplate from "./TermOrdersBannerTemplate";
import TermOrdersCopy from "./TermOrdersCopy";
import ShippingAddressDialog from "../ShippingAddress/ShippingAddressDialog";
import { ShippingAddress } from "common/api/decimal/methods/course";
import { UserPreferenceKey } from "common/api/decimal/methods/user";
import useUserPreference from "routes/home/actions/user/useUserPreference";
import { focusMainContent } from "common/utils/focus";
import { useCoursesLoaderData } from "../coursesLoader";

const AddressBanner = ({
  preferredAddress,
  bannerSeenPreferenceKey,
}: {
  preferredAddress?: ShippingAddress;
  bannerSeenPreferenceKey?: UserPreferenceKey;
}) => {
  const [showingDialog, setShowingDialog] = useState(false);
  const { currentTerm } = useCoursesLoaderData();
  const [dismissExpiredOn, setExpiredOn] = useUserPreference<string>(
    bannerSeenPreferenceKey
  );

  const variant = preferredAddress
    ? "confirm shipping address"
    : "add shipping address";

  const userDismissed =
    dismissExpiredOn && variant === "confirm shipping address"
      ? new Date(dismissExpiredOn) >= new Date()
      : false;

  if (userDismissed || !currentTerm) {
    return null;
  }

  const values = {
    address: preferredAddress,
  };

  const onClose = () => {
    setExpiredOn(currentTerm.endOn);
    focusMainContent();
  };

  return (
    <>
      <TermOrdersBannerTemplate
        type={variant === "add shipping address" ? "Alert" : "Warning"}
        title={<TermOrdersCopy type="title" variant={variant} />}
        content={
          <TermOrdersCopy type="content" variant={variant} values={values} />
        }
        CTAText={<TermOrdersCopy type="cta" variant={variant} />}
        onCTAClick={() => setShowingDialog(true)}
        onClose={variant === "confirm shipping address" ? onClose : undefined}
      />
      {showingDialog && (
        <ShippingAddressDialog onRequestClose={() => setShowingDialog(false)} />
      )}
    </>
  );
};

export default AddressBanner;
